import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center max-w-md px-6">
        <h1 className="mb-4 text-6xl font-extrabold text-foreground tracking-tight">404</h1>
        <p className="mb-6 text-lg text-muted-foreground">The page you're looking for doesn't exist.</p>
        <Button asChild className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold rounded-md">
          <a href="/">Return to Home</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
